
























































import { AvatarChangeModal } from '@/components/geek-profile';
import { GeekItem } from '@/models';
import { typedStore } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'PersonalInfo',
  props: {
    geek: Object as () => GeekItem,
    isClassified: Boolean,
    leaderboardPosition: Number,
  },
  components: {
    AvatarChangeModal,
  },
  data() {
    return {
      isNicknameEdited: false,
    };
  },
  computed: {
    isMyProfile(): boolean {
      return this.geek.id === typedStore(this).state.geek.current.id;
    },
    geekLeaderboardPosition(): string {
      switch (this.leaderboardPosition) {
        case 1:
          return 'first';
        case 2:
          return 'second';
        case 3:
          return 'third';
        default:
          return '';
      }
    },
    geekAvatarUrl(): string {
      return this.geek.avatarUrl + '?t=' + Math.floor(Date.now() / 1000);
    },
    geekNickChangeTooltipText(): string {
      if (this.isMyProfile) {
        this.$root.$emit('bv::enable::tooltip', 'geek-name');
        return this.$t('geek-profile.tooltips.nick-edit') as string;
      } else {
        this.$root.$emit('bv::disable::tooltip', 'geek-name');
        return '';
      }
    },
  },
  methods: {
    openAvatarChangeModal() {
      this.$bvModal.show('avatar-change-modal');
    },
    changeGeekNick() {
      if (!this.isMyProfile) {
        return;
      }
      this.isNicknameEdited = true;
      this.$root.$emit('bv::hide::tooltip', 'geek-name');
      this.$root.$emit('bv::disable::tooltip', 'geek-name');
    },
    updateNick() {
      this.$emit('nickChange', (this.$refs.nick as HTMLInputElement).value);
      this.isNicknameEdited = false;
      this.$root.$emit('bv::enable::tooltip', 'geek-name');
    },
  },
  directives: {
    focus: {
      inserted: (el) => {
        el.focus();
      },
    },
  },
});
